export default __webpack_public_path__ + "static/media/konstantin_m.79a5a71d.jpg";